<template>
  <div>
    <div class="case-top-line">
      <div class="case-top-line-left">
        <div
          :class="['case-top-dot', 'indikator', !predmet_info.is_archived ? 'i-g' : predmet_info.is_archived && !predmet_info.is_destroyed ? 'i-g-archived' : 'i-g-destroyed']">
        </div>
        <div class="case-name">{{ predmet_info.ime_predmeta }}</div>
        <div class="case-tab-buttons-wrapper">
          <div v-if="is_permission_inside('case.edit')" @click="changeView('edit')"
            class="edit-case-name add-button add-pen">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
              <g>
                <g>
                  <path fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                </g>
              </g>
            </svg>
          </div>
          <div @click="openKalForm()" class="edit-case-name add-button kal-button">
            K
          </div>
          <div class="edit-case-name add-button kal-button" @click="openIzvjestajEdit()">
            R
          </div>

          <div class="edit-case-name add-button time-edit-button"
            :class="[predmet_info.client_portal_deadline && predmet_info.client_portal_deadline.length > 0 ? 'active' : '']" @click="case_portal = true">
            <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 408.346 408.346" xml:space="preserve">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <g>
                  <path
                    d="M157.502,119.135l-29.472-5.896c-1.49-1.704-3.323-3.076-5.363-4.039c2.319-2.593,4.285-5.211,5.781-7.379 c3.604-5.228,6.604-10.859,8.684-16.293c1.026-2.291,1.893-4.593,2.605-6.852c2.791-2.342,4.436-5.845,4.436-9.518v-8.996 c0-2.586-0.807-5.107-2.299-7.204V40.293C141.873,18.075,123.797,0,101.576,0H88.512C66.295,0,48.217,18.075,48.217,40.293v12.669 c-1.488,2.096-2.303,4.618-2.303,7.202v8.996c0,3.672,1.643,7.168,4.441,9.516c0.71,2.254,1.58,4.562,2.606,6.857 c2.075,5.431,5.077,11.063,8.684,16.287c1.498,2.176,3.466,4.796,5.794,7.396c-2.033,0.965-3.854,2.335-5.341,4.03l-29.03,5.881 c-7.666,1.552-13.179,8.29-13.179,16.119v106.456c0,2.463,0.546,4.802,1.516,6.896v11.667c0,7.943,6.44,14.389,14.388,14.389 c2.898,0,5.598-0.866,7.855-2.342v110.204c0,14.266,11.565,25.829,25.832,25.829c14.258,0,25.822-11.564,25.822-25.829 c0,14.266,11.559,25.829,25.83,25.829c14.26,0,25.818-11.564,25.818-25.829V272.313c2.264,1.476,4.961,2.342,7.861,2.342 c7.949,0,14.385-6.446,14.385-14.389v-11.667c0.979-2.096,1.521-4.433,1.521-6.896V135.263 C170.718,127.424,165.184,120.671,157.502,119.135z M87.313,146.105c-0.107,1.053-0.851,1.936-1.876,2.219 c-0.229,0.066-0.46,0.095-0.692,0.095c-0.799,0-1.569-0.369-2.06-1.026l-7.262-9.629c-0.335-0.447-0.518-0.995-0.518-1.557 l0.008-15.429c0.002-0.907,0.477-1.745,1.253-2.215c0.772-0.467,1.737-0.491,2.538-0.071c2.112,1.12,4.223,1.87,6.271,2.231 c1.229,0.221,2.129,1.294,2.129,2.544v6.437c0.371,0.149,0.705,0.375,0.976,0.674c0.49,0.546,0.727,1.269,0.65,1.994 L87.313,146.105z M115.173,136.21c0,0.56-0.18,1.107-0.519,1.553l-7.245,9.62c-0.498,0.658-1.265,1.033-2.062,1.033 c-0.231,0-0.469-0.034-0.699-0.095c-1.022-0.286-1.766-1.167-1.873-2.225l-1.412-13.724c-0.076-0.725,0.159-1.448,0.648-1.994 c0.268-0.3,0.604-0.525,0.977-0.674v-6.437c0-1.25,0.898-2.323,2.13-2.544c2.042-0.362,4.151-1.111,6.266-2.229 c0.805-0.419,1.767-0.396,2.54,0.071c0.778,0.468,1.249,1.308,1.249,2.215V136.21z M117.28,93.801 c-6.315,9.16-12.229,13.261-15.3,13.261H88.107c-3.067,0-8.986-4.102-15.302-13.261c-4.983-7.229-8.451-15.227-9.264-21.402 L63.4,71.33l-2.506-1.627c-0.733-0.477-1.177-1.289-1.177-2.167v-4.248c0-1.428,1.157-2.584,2.585-2.584h1.051v-4.607 c0-0.98,0.555-1.872,1.43-2.311c3.558-1.772,10.616-4.753,17.924-4.753c5.822,0,10.657,1.94,14.363,5.765 c4.611,4.771,9.935,7.189,15.804,7.189c3.333,0,6.765-0.785,10.22-2.335c0.799-0.358,1.723-0.288,2.462,0.188 c0.345,0.223,0.62,0.519,0.825,0.865h1.408c1.426,0,2.586,1.156,2.586,2.584v4.249c0,0.877-0.446,1.689-1.178,2.166l-2.504,1.627 l-0.144,1.069C125.732,78.572,122.267,86.571,117.28,93.801z">
                  </path>
                  <path
                    d="M187.086,2.803c-1.147,0-2.289,0.024-3.432,0.043V35.9c1.152-0.23,2.298-0.356,3.432-0.356 c13.51,0,28.565,16.521,40.273,44.194c4.211,9.951,7.846,20.93,10.875,32.701c-16.49-1.919-33.655-2.912-51.148-2.912 c-1.146,0-2.288,0.016-3.432,0.024v32.746c1.145-0.009,2.283-0.03,3.432-0.03c20.051,0,39.542,1.387,57.863,4.043 c2.656,18.321,4.043,37.812,4.043,57.863s-1.387,39.542-4.043,57.863c-18.321,2.656-37.813,4.043-57.863,4.043 c-1.148,0-2.287-0.021-3.432-0.03v32.746c1.144,0.009,2.285,0.024,3.432,0.024c17.493,0,34.658-0.993,51.148-2.912 c-3.029,11.771-6.664,22.75-10.875,32.701c-11.708,27.673-26.764,44.194-40.273,44.194c-1.134,0-2.279-0.126-3.432-0.356v33.052 c1.143,0.019,2.284,0.044,3.432,0.044c111.036,0,201.37-90.334,201.37-201.37S298.122,2.803,187.086,2.803z M247.505,46.744 c44.458,17.121,79.89,52.552,97.011,97.01c-6.148-3.553-12.893-6.9-20.236-10.007c-15.239-6.448-32.494-11.696-51.127-15.641 c-3.944-18.632-9.192-35.888-15.641-51.126C254.405,59.638,251.059,52.893,247.505,46.744z M247.505,361.602 c3.554-6.148,6.9-12.893,10.007-20.236c6.448-15.239,11.696-32.494,15.641-51.127c18.633-3.944,35.888-9.193,51.126-15.641 c7.343-3.107,14.089-6.454,20.237-10.008C327.395,309.049,291.963,344.481,247.505,361.602z M311.522,244.447 c-9.951,4.211-20.93,7.845-32.701,10.875c1.919-16.49,2.912-33.655,2.912-51.148s-0.993-34.658-2.912-51.148 c11.771,3.03,22.75,6.664,32.7,10.875c27.673,11.708,44.194,26.764,44.194,40.273C355.715,217.682,339.193,232.738,311.522,244.447 z">
                  </path>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div class="case-top-line-right">
        <div class="case-actions-date">
          <div class="case-kreiran">
            {{ $t('components.case_nav.created_at') }}: <b>{{ predmet_info.datum_pocetka != undefined ?
              showDate(predmet_info.datum_pocetka) : ''
            }}</b>
          </div>
          <div v-if="predmet_info.is_archived" class="case-kreiran">
            {{ $t('components.case_nav.archived_at') }}: <b>{{ predmet_info.datum_arhiviranja ?
              showDate(predmet_info.datum_arhiviranja) : 'Nepoznato'
            }}</b>
          </div>
          <div v-if="predmet_info.is_destroyed" class="case-kreiran">
            {{ $t('components.case_nav.destroyed_at') }}: <b>{{ predmet_info.datum_unistenja ?
              showDate(predmet_info.datum_unistenja) : 'Nepoznato'
            }}</b>
          </div>
          <div v-if="predmet_info.client_portal_deadline.length > 0" class="case-kreiran">
            <b> {{ $t('components.case_nav.pk_expires') }}: </b>{{ showDate(predmet_info.client_portal_deadline[0].expiry_date) }}

          </div>


        </div>
      </div>
    </div>
    <div class="case-tabs">
      <div :class="[
        'case-tab',
        'case-tab-predmet',
        current_tab == 'Case' ? 'active' : '',
      ]" @click="changeView('')">
        {{ $t('components.case_nav.l1') }}
      </div>
      <div :class="[
        'case-tab',
        'case-tab-sudionici',
        current_tab == 'Sudionici' ? 'active' : '',
      ]" @click="changeView('sudionici')">
        {{ $t('components.case_nav.l2') }}
      </div>
      <div :class="['case-tab', 'case-tab-spisi', current_tab == 'Spisi' ? 'active' : '',]"
        v-if="is_permission_inside('case.spis.read')" @click="changeView('spisi')">
        {{ $t('components.case_nav.l3') }}
      </div>
      <div v-if="is_permission_inside('case.comunication.move', false)"
        :class="['case-tab', 'case-tab-subtabs', 'case-tab-pošta', current_tab == 'Posta' ? 'active' : '']"
        @click="changeView('posta')">
        {{ $t('components.case_nav.l4') }}
      </div>
      <div :class="['case-tab', 'case-tab-subtabs', 'case-tab-pošta', current_tab == 'Naplata' ? 'active' : '']"
        v-if="is_permission_inside('case.payment.read', false)" @click="changeView('naplata')">
        {{ $t('components.case_nav.l5') }}
      </div>
      <div :class="['case-tab', 'case-tab-mobile', 'case-tab-pošta', current_tab == 'Kalendar' ? 'active' : '']"
        @click="changeView('kalendar')" v-if="is_permission_inside('case.calendar.read')">
        {{ $t('components.case_nav.l6_2') }}
      </div>
      <div class="case-tab-wrapper-subtabs" id="kalendar-maintab-case">
        <div
          :class="['case-tab', 'case-tab-subtabs', 'last', 'case-tab-financije', current_tab == 'Kalendar' || current_tab == 'Planer' ? 'active' : '']"
          @click="changeView('kalendar')" v-if="is_permission_inside('case.calendar.read')">
          <span> {{ $t('components.case_nav.l6') }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 1.2C4.2504 1.2 1.2 4.2504 1.2 8C1.2 11.7496 4.2504 14.8 8 14.8C11.7496 14.8 14.8 11.7496 14.8 8C14.8 4.2504 11.7496 1.2 8 1.2ZM8 16C3.5888 16 0 12.4112 0 8C0 3.5888 3.5888 0 8 0C12.4112 0 16 3.5888 16 8C16 12.4112 12.4112 16 8 16Z"
              fill="#65656D" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.99965 10.235C7.84045 10.235 7.68685 10.1718 7.57485 10.0582L4.79805 7.26941C4.56365 7.03421 4.56525 6.65421 4.79965 6.42061C5.03485 6.18701 5.41485 6.18701 5.64845 6.42221L7.99965 8.78541L10.3516 6.42221C10.5852 6.18701 10.9652 6.18701 11.2004 6.42061C11.4348 6.65421 11.4356 7.03421 11.202 7.26941L8.42445 10.0582C8.31245 10.1718 8.15885 10.235 7.99965 10.235Z"
              fill="#65656D" />
          </svg>
        </div>
        <div class="subtabs" id="subtabs-kalendar-case">
          <div :class="['sub-tab', 'case-tab-pošta', current_tab == 'Kalendar' ? 'active' : '']"
            @click="changeView('kalendar')" v-if="is_permission_inside('case.calendar.read')">
            <span> {{ $t('components.case_nav.l6_1') }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
              <path d="M1.06055 5.8539H12.7452" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M9.81234 8.4142H9.81841" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M6.90316 8.4142H6.90923" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M3.98812 8.4142H3.99419" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M9.81234 10.9618H9.81841" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M6.90316 10.9618H6.90923" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M3.98812 10.9618H3.99419" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M9.55073 1V3.1573" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M4.25483 1V3.1573" stroke="#606076" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9.67845 2.03516H4.12764C2.20247 2.03516 1 3.10761 1 5.07893V11.0115C1 13.0138 2.20247 14.1111 4.12764 14.1111H9.67238C11.6036 14.1111 12.8 13.0324 12.8 11.0611V5.07893C12.8061 3.10761 11.6097 2.03516 9.67845 2.03516Z"
                stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div :class="['sub-tab', 'case-tab-pošta', current_tab == 'Planer' ? 'active' : '']"
            @click="changeView('planer')">
            <span> {{ $t('components.case_nav.l6_2') }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M9.07697 1.5H3.92243C2.12616 1.5 1 2.77184 1 4.57168V9.42832C1 11.2282 2.12081 12.5 3.92243 12.5H9.07638C10.8786 12.5 12 11.2282 12 9.42832V4.57168C12 2.77184 10.8786 1.5 9.07697 1.5Z"
                stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.38281 7.00008L5.79438 8.41106L8.61633 5.58911" stroke="#606076" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>

      <div :class="['case-tab', 'case-tab-mobile', 'case-tab-pošta', current_tab == 'Planer' ? 'active' : '']"
        @click="changeView('planer')">Planer</div>
    </div>
    <v-dialog v-model="kal_popup" width="564px">
      <v-card color="universal-vcard">
        <div :class="['universal-vdialog-title', 'archive-title']">
          {{ $t("components.kal_popup.create_kal") }}
        </div>
        <v-form ref="form" v-model="form" class="pa-4 pt-6">
          <v-text-field :rules="[rules.title]" :label="$t('components.kal_popup.title')" v-model="kal_object.title"
            class="case-date-picker archive-date-picker"></v-text-field>
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :rules="[rules.date]" :label="$t('components.kal_popup.choose_date')" v-model="dateText"
                readonly append-icon="mdi-calendar" v-bind="attrs" @click="menu1 = !menu1" v-on="on"
                class="case-date-picker archive-date-picker"></v-text-field>
            </template>
            <v-date-picker locale="hr" :first-day-of-week="1" v-model="kal_object.date" no-title></v-date-picker>
          </v-menu>
          <v-textarea :label="$t('components.kal_popup.napomene')" v-model="kal_object.description"
            class="case-date-picker archive-date-picker"></v-textarea>
          <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="kal_popup = false;"> {{
              $t("repetitive.cancel") }}
            </div>
            <div class="universal-vdialog-button vbutton-primary" @click="createKal()"> {{ $t("repetitive.create") }}
            </div>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="case_portal" width="800px">
      <v-card class="version-unos" color="universal-vcard">
        <div :class="['universal-vdialog-title', 'archive-title']">
          <span v-if="predmet_info.client_portal_deadline.length == 0">{{ $t('components.case_portal.enable_title') }}</span>
          <span v-else>{{ $t('components.case_portal.disable_title') }}</span>
        </div>

        <div class="sifra-opis-wrapper">
          <label class="form-label">
            <span v-if="predmet_info.client_portal_deadline.length == 0">{{ $t('components.case_portal.disable_description') }}</span>
            <span v-else>{{ $t('components.case_portal.enable_description') }}</span>
          </label>
        </div>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="case_portal = false">
            {{ $t("repetitive.cancel") }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="changeValueOfExpiration()">
            {{ $t("repetitive.save") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="izvjestaj_dialog" width="800px">
      <v-card class="version-unos" color="universal-vcard">
        <div :class="['universal-vdialog-title', 'archive-title']">
          {{ $t('components.case_state.title', { date: stateDateText }) }}
        </div>
        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :rules="[rules.date]" label="Stanje na datum" v-model="stateDateText" readonly
              append-icon="mdi-calendar" v-bind="attrs" @click="menu2 = !menu2" v-on="on"
              class="case-date-picker archive-date-picker"></v-text-field>
          </template>
          <v-date-picker locale="hr" :first-day-of-week="1" v-model="izvjestaj_date"
            @change="setReportData(izvjestaj_date, false)" no-title :event-color="'green'"
            :events="all_report_states.map((s) => s.state_date.split('T')[0])"></v-date-picker>
        </v-menu>
        <div class="sifra-opis-wrapper">
          <label class="form-label">
            <span></span>
          </label>
          <ckeditor :editor="editor" v-model="izvjestaj"></ckeditor>
        </div>
        <div class="vdialog-buttons-wrapper">
          <div v-if="lastDate" class="universal-vdialog-button vbutton-secondary narrow" @click="fillByDate(lastDate)">
            {{ $t('components.case_state.btn2', { date: showDate(lastDate) }) }}
          </div>
          <div class="universal-vdialog-button vbutton-secondary narrow" @click="regenerateTemplate">
            {{ $t('components.case_state.btn1') }}
          </div>
          <div class="universal-vdialog-button vbutton-secondary" @click="cancelReport">
            {{ $t("repetitive.cancel") }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="saveReport">
            {{ $t("repetitive.save") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warn_user" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t('components.case_state.warning') }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="warn_user = false;"> {{ $t("repetitive.cancel")
            }}
          </div>
          <div class="universal-vdialog-button vbutton-primary" @click="finishClose"> {{ $t("repetitive.discard") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import moment from "moment";
import permissioner from "@/services/permissioner.js";
import gsap from 'gsap';
import $ from 'jquery';
import predmeti from "@/apiCallers/promise_handler_db/predmeti";
import { changeCaseExpirationValue } from "@/apiCallers/promise_handler_db/clientPortal";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@/plugins/ckeditor_build';

export default {
  props: ['current_tab', "predmet_info", "permission", "mapped_permission"],
  data() {
    return {
      kal_popup: false,
      kal_object: {
        title: '',
        description: '',
        date: '',
        createdBy: null,
        spis: null,
      },
      case_portal: false,
      rules: {
        title: v => !!v || this.$t('components.kal_popup.errors.err1'),
        date: v => !!v || this.$t('components.kal_popup.errors.err2'),
      },
      menu1: false,
      menu2: false,
      form: false,
      editor: ClassicEditor,
      izvjestaj_template: '',
      izvjestaj_initial: '',
      izvjestaj: '',
      izvjestaj_id: null,
      izvjestaj_date: '',
      izvjestaj_dialog: false,
      warn_user: false,
      all_report_states: [],
    }
  },
  components: {
    ckeditor: CKEditor.component
  },
  computed: {
    /**
     * Getter for Kal date input field text
     */
    dateText() {
      return moment(this.kal_object.date).format('DD.MM.yyyy.');
    },
    /**
     * Getter for Case State date input field
     */
    stateDateText() {
      return moment(this.izvjestaj_date).format('DD.MM.yyyy.');
    },
    /**
     * Returns last date available date for refilling
     */
    lastDate() {
      const latest_date = this.all_report_states.slice().reverse().filter((st) => moment(st.state_date).isBefore(moment(this.izvjestaj_date)))[0];
      return latest_date ? moment(
        latest_date.state_date
      ) : '';
    },
  },
  watch: {
    /**
     * Watches for case change and sets case number to breadcrumbs
     * Also sets Case State report template data
     */
    predmet_info: function () {
      this.$store.state.paginacija.subpages = [this.predmet_info.broj_predmeta];
      this.izvjestaj_template =
        `<p>
          <strong>${this.$t('components.case_state.template.t1')}&emsp;&emsp;&emsp;&nbsp;</strong>${this.predmet_info.ime_predmeta}<br/>
          <strong>${this.$t('components.case_state.template.t2')}&emsp;&emsp;&ensp;</strong>${this.predmet_info.prav_connect_stranka.map((st) => `${st.pravna_osoba.ime}`)
          .concat(this.predmet_info.connect_fiz_stranka.map(el => el.fizicka_osoba.ime + ' ' + el.fizicka_osoba.prezime)).join(', ')}<br/>
          <strong>${this.$t('components.case_state.template.t3')}&nbsp;</strong>${this.predmet_info.prav_connect_protustranka.map((st) => `${st.pravna_osoba.ime}`)
          .concat(this.predmet_info.connect_fiz_protustranka.map(el => el.fizicka_osoba.ime + ' ' + el.fizicka_osoba.prezime)).join(', ')}<br/>
          <strong>${this.$t('components.case_state.template.t4')}</strong>&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;${this.predmet_info.spis[0].institucija ? this.predmet_info.spis[0].institucija.naziv : ''}<br/>
          <strong>${this.$t('components.case_state.template.t5')}</strong>&emsp;&emsp;${this.predmet_info.spis[0].posl_br ? this.predmet_info.spis[0].posl_br : ''}<br/>
          <strong>${this.$t('components.case_state.template.t6')}</strong>&emsp;&emsp;&emsp;&emsp;&emsp;${this.predmet_info.opis_predmeta}<br/>
          <strong>${this.$t('components.case_state.template.t7')}</strong>&emsp;&emsp;&emsp;&emsp;&ensp;${this.predmet_info.VPS ? this.predmet_info.VPS : ''} ${this.predmet_info.VPS ? this.predmet_info.currency.short_name : ''}
      </p>
      <p><strong><u>${this.$t('components.case_state.template.t8')}</u></strong></p><br/>`
    }
  },
  methods: {
    /**
     * Fills Case State report by state from passed date
     * @param {string} date 
     */
    fillByDate(date) {
      const found_state = this.all_report_states.find((st) => moment(st.state_date).format('DD.MM.yyyy.') == moment(date).format('DD.MM.yyyy.'));
      console.log(found_state)
      this.izvjestaj = found_state.report_html;
    },
    /**
     * Adds Case State report template data to current report text
     */
    regenerateTemplate() {
      this.izvjestaj = this.izvjestaj_template + this.izvjestaj;
    },
    /**
     * Checks if user wants to close Case State 
     * report popup and warns user if there are unsaved changes,
     * if not calls report closing function
     */
    cancelReport() {
      if (this.izvjestaj != this.izvjestaj_initial) {
        this.warn_user = true;
      }
      else {
        this.finishClose()
      }
    },
    /**
     * Closes Case State report popup and sets data to initial state
     */
    finishClose() {
      this.izvjestaj_dialog = false;
      this.warn_user = false;
      this.izvjestaj_initial = '';
      this.izvjestaj = '';
      this.izvjestaj_id = null;
      this.izvjestaj_date = moment(Date.now()).format("yyyy-MM-DD");;
    },
    /**
     * Sets inital data to Case State report popup
     * Checks for various possiblilities e.g. 
     * If Case State report is initially opened sets it to latest found state,
     * if not tries to find state by passed chosen_date and sets it for user to edit,
     * else sets template data for user to fill
     * @param {string} chosen_date 
     * @param {boolean} initial_open 
     */
    setReportData(chosen_date, initial_open) {
      let current_state;
      if (!initial_open) {
        const found_state = this.all_report_states.find((state) => moment(state.state_date).format("yyyy-MM-DD") == moment(chosen_date).format("yyyy-MM-DD"));
        // Ako je pronađeno stanje na odabrani dan postavi edit mode
        if (found_state) {
          current_state = found_state;
          this.izvjestaj_id = current_state.uid
        }
        else {
          current_state = null;
        }
      }
      else {
        // Ako je inicijalni open pronađi zadnji uneseni state i postavi ga na edit
        current_state = this.all_report_states.length > 0 ? this.all_report_states[this.all_report_states.length - 1] : null;
        if (current_state) {
          this.izvjestaj_id = current_state.uid
        }
      }
      // Ako nije pronađen state za editiranje onda postavi create mode za odabrani dan
      if (current_state == null) {
        this.izvjestaj = this.izvjestaj_template;
        this.izvjestaj_id = null;
      }
      // Inače postavi edit mode za odabrani dan
      else {
        this.izvjestaj = current_state.report_html;
        this.izvjestaj_initial = current_state.report_html;
        this.izvjestaj_date = moment(current_state.state_date).format("yyyy-MM-DD");
      }
    },
    /**
     * Opens Case State report popup
     */
    openIzvjestajEdit() {
      this.izvjestaj_dialog = true;
      this.all_report_states = this.predmet_info.case_report.sort((a, b) => new Date(a.state_date) - new Date(b.state_date));
      this.setReportData(this.izvjestaj_date, true);
      setTimeout(() => {
        gsap.to('.sifra-opis-wrapper', 1, { width: '99%' })
        gsap.to('.sifra-opis-wrapper', 1, { width: '100%' })
      }, 100);
    },
    /**
     * Saves Case State report to database
     */
    async saveReport() {
      await predmeti.saveCaseReport(this.izvjestaj_id, this.$route.params.uid, this.izvjestaj, this.izvjestaj_date).then((res) => {
        this.predmet_info.case_report = res.data;
        this.$store.state.current_selected_case.case_report = res.data;
        this.finishClose();
      })
    },
    /**
     * Creates new Kal in the database
     */
    async createKal() {
      this.$refs.form.validate();
      if (this.kal_object.title != '' && this.kal_object.date != '') {
        this.kal_object.createdBy = this.$store.state.logged_in_user.uid;
        await predmeti.addNewKal(this.kal_object, this.$route.params.uid).then((resp) => {
          this.$store.state.is_intentional_reload = true;
          location.reload();
        })
      }
    },
    /**
     * Checks for user permission
     * Needed for showing tabs Case Tabs to the user based on his roles in the system
     * @param {string} wanted_permission 
     * @param {boolean} assistent_check 
     */
    is_permission_inside(wanted_permission, assistent_check = true) {
      return permissioner.check_case_permsision(wanted_permission, assistent_check)
    },
    /**
     * Changes view based on clicked Case Tab
     * @param {string} nastavak 
     */
    changeView(nastavak) {
      if (this.$route.path.includes('archived-case')) {
        this.$router.push("/archived-case/" + this.$route.params.uid + "/" + nastavak);
      } else {
        this.$router.push("/case/" + this.$route.params.uid + "/" + nastavak);
      }
    },
    /**
     * 
     * @param {Timestamp} date 
     */
    showDate(date) {
      return moment(date.toString()).format("l");
    },
    /**
     * Opens Kal creation popup form
     */
    openKalForm() {
      this.kal_popup = true;
      if (this.kal_object.title == '') {
        this.kal_object.title = `KAL - ${this.predmet_info.ime_predmeta}`;
      }
      if (this.predmet_info.spis.length > 0) {
        this.kal_object.spis = this.predmet_info.spis[0].id_spis;
      }
    },

    async changeValueOfExpiration() {
      this.case_portal = false;
      console.log("Client portal deadlines", this.predmet_info.client_portal_deadline.length > 0)

      await changeCaseExpirationValue(this.predmet_info.group_url, (this.predmet_info.client_portal_deadline.length > 0)).then(() => location.reload())
    }
  },
  mounted() {
    this.kal_object.date = moment(Date.now()).add(1, 'days').format("yyyy-MM-DD");
    this.izvjestaj_date = moment(Date.now()).format("yyyy-MM-DD");
    setTimeout(() => {
      const sub = document.getElementById("subtabs-kalendar-case");
      $('#kalendar-maintab-case').hover(
        function () {
          gsap.fromTo(sub, 0.3, { display: 'none' }, { display: 'block' })
          gsap.fromTo(sub, 0.3, { opacity: 0 }, { opacity: 1 });
        },
        function () {
          gsap.fromTo(sub, 0.3, { display: 'block' }, { display: 'none' })
          gsap.fromTo(sub, 0.3, { opacity: 1 }, { opacity: 0 });
        }
      );
    }, 200)
    setTimeout(() => {
      this.$store.state.paginacija.title = this.$t("breadcrumbs.case_single");
      this.$store.state.paginacija.back_link = '/cases'
    }, 500);
   

  },
  destroyed() {
    $("#kalendar-maintab-case").off();
  }
};
</script>